import { ReactNode } from 'react';
import './Callout.scss';

const Callout = ({
    children,
    eyebrow,
    title,
    description
} : {
    children?: ReactNode,
    eyebrow: string;
    title: string;
    description: string;
}) => {
    return (
        <section className='callout'>
            <div className='callout-title'>
                <h2 className='heading'>
                    <span className='eyebrow'>{eyebrow}</span>
                    {title}
                </h2>
                <p>
                    {description}
                </p>
            </div>
            <div className='callout-content'>
                {children}
            </div>
        </section>
    );
}

export default Callout;